import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import tableHelpers from '../helpers/TableHelpers.js'
import RichTable from '../components/richTable/RichTable.jsx'
import { createDateSorter } from '../components/richTable/sorters.js'
import AlgoStatsTooltip from '../components/AlgoStatsTooltip.js'
import EditTrade from './EditTrade.js';
import AutomateTrade from '../trades/AutomateTrade.js'
import OHLCBarChart from '../components/OHLCBarChart.js'
import StockQuickLookDrawer from '../stock/StockQuickLookDrawer.js'
import { Chart } from "react-google-charts";
import Drawer from '@mui/material/Drawer';
import TradingViewChart from '../stock/TradingViewChart.js'
import AlgoDrawer from '../algos/AlgoDrawer.js'
import TradeDetailsDrawer from '../trades/TradeDetailsDrawer.js'

function ActiveBonusTrades(props) {
    const [data, setData] = useState([]);
    const [isEditingTrade, setIsEditingTrade] = useState(false);
    const [editTrade, setEditTrade] = useState(null)
    const [updates, setUpdates] = useState(0);
    const [isPlacingOrder, setIsPlacingOrder] = useState(false);
    const [trade, setTrade] = useState(null);
    const [quotes, setQuotes] = useState([]);
    const [popupChartSymbol, setPopupChartSymbol] = useState(null);

    useEffect(() => {
        (async function () {

            let url = `/api/activeUserTrades?planId=` + props.planId + `&userId=` + props.userId + `&accountId=0`
            let text = await (await (fetch(url))).json()
            console.log("activeTrades", text);
            setData(text);

            if (text && text.length) {
                const q = await (await fetch(`/api/quote?symbols=` + text.map(t => t.trade_symbol).join(','))).json();
                console.log("quotes", q);
                setQuotes(q);
            }

        })();
    }, [props.planId, props.userId, props.accountId, updates, props.updates]);

    function getTrades() {
        return data.map(trade => {
            let userProfit = (trade.close - trade.user_purchase_price) / trade.user_purchase_price * 100;
            let userAllocation = (trade.user_amount * trade.user_purchase_price * 100) / props.accountValue * 100
            return {
                idplan_trades: trade.idplan_trades,
                purchase_date: trade.purchase_date,
                display_name: trade.display_name,
                algoId: trade.algoId,
                trade_symbol: trade.trade_symbol,
                algo_type: trade.algo_type,
                close: trade.user_purchase_price ? trade.user_purchase_price : trade.close,
                currentPrice: trade.current_price,
                quote: trade.user_sell_price ? trade.user_sell_price : trade.current_price,
                profit: userProfit,
                marketValue: trade.current_price * trade.user_amount,
                allocation: trade.user_trade_is_option ? userAllocation : trade.allocation * (trade.percent_of_allocation / 100),
                netProfit: userProfit,
                dollarProfit: (trade.current_price - trade.close) * trade.user_amount,
                winning_percentage: trade.winning_percentage,
                avg_duration: trade.avg_duration,
                avg_profit: trade.avg_profit,
                avg_win: trade.avg_win,
                avg_loss: trade.avg_loss,
                robustness_overall: trade.robustness_overall,
                user_symbol: trade.user_symbol,
                user_trade_is_option: trade.user_trade_is_option,
                user_amount: trade.user_amount,
                user_purchase_price: trade.user_purchase_price,
                user_sell_price: trade.user_sell_price,
                user_trade_id: trade.user_trade_id,
                user_profit: isNaN(userProfit) ? undefined : userProfit
            }
        });
    }

    function algoLinkFormatter(cell, row) {
        let algoid = row.algoId;
        return (
            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                <AlgoDrawer link={cell} planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} algoId={algoid} role={props.role} />
                &nbsp;&nbsp;<AlgoStatsTooltip algoId={algoid} />
            </div>

        )
    }

    function getStats() {

        let stats = { count: 0, winners: 0, losers: 0, avgProfit: 0.0, avgNetProfit: 0.0, avgWin: 0.0, avgLoss: 0.0, maxWin: 0.0, maxLoss: 0.0, netProfit: 0.0, totalMarketValue: 0.0, todaysChange: 0 }

        getTrades().forEach(trade => {
            let profit = trade.dollarProfit
            let netProfit = trade.dollarProfit;
            stats.avgProfit = ((stats.avgProfit * stats.count) + profit) / (stats.count + 1);
            stats.avgNetProfit = ((stats.avgNetProfit * stats.count) + netProfit) / (stats.count + 1);
            stats.netProfit += netProfit;
            stats.totalMarketValue += trade.marketValue

            let quote = quotes.find(q => q.symbol === trade.trade_symbol);
            if (quote) {
                let purchaseDate = new Date(trade.purchase_date);
                let today = new Date();
                if (purchaseDate.toDateString() !== today.toDateString()) {
                    let change = quote.last - quote.pclose;
                    stats.todaysChange += change * trade.user_amount;
                }
            }


            if (profit > 0) {
                if (profit > stats.maxWin) stats.maxWin = profit;
                stats.avgWin = ((stats.avgWin * stats.winners) + profit) / (stats.winners + 1);
                ++stats.winners;
            } else if (profit < 0) {
                if (profit < stats.maxLoss) stats.maxLoss = profit;
                stats.avgLoss = ((stats.avgLoss * stats.losers) + profit) / (stats.losers + 1);
                ++stats.losers;
            }
            ++stats.count;
        });
        stats.winningPct = (stats.winners / (stats.count) * 100);

        return [{
            netProfit: stats.netProfit,
            winners: stats.winners,
            losers: stats.losers,
            count: stats.count,
            avgProfit: stats.avgProfit,
            avgNetProfit: stats.avgNetProfit,
            avgWin: stats.avgWin,
            avgLoss: stats.avgLoss,
            winningPct: stats.winningPct,
            totalMarketValue: stats.totalMarketValue,
            todaysChange: stats.todaysChange
        }]
    }

    function showEditModal(trade) {
        console.log("Opening modal for ", trade);
        setEditTrade(trade)
        setIsEditingTrade(true);
    }

    function sharesFormatter(cell, row) {
        return <>
            {tableHelpers.intFormatter(cell)} <Link className="bg-transparent" onClick={() => showEditModal(row)}>✏️</Link>

            {props.brokerage ? <Link onClick={() => openPlaceTradeModal(row.trade_symbol, Number(cell) * -1)}> ⤵️</Link> : null}
        </>
    }

    function onStopEditingTrade() {
        console.log("onStopEditingTrade");
        setIsEditingTrade(false)
        setEditTrade(null);
        setUpdates(updates + 1);

        if (props.onUpdate) props.onUpdate();
    }

    function todayChangeFormatter(symbol) {
        let quote = quotes.find(q => q.symbol === symbol);
        if (quote) {
            let highChange = (quote.high - quote.pclose) / quote.pclose * 100;
            let lowChange = (quote.low - quote.pclose) / quote.pclose * 100;
            let openChange = (quote.open - quote.pclose) / quote.pclose * 100;
            let change = quote.percentChange;
            console.log("quote", quote);

            return (
                <OHLCBarChart width="80px" hideLabels={true} high={highChange} low={lowChange} open={openChange} close={change} />
            );
        } else return "";
    }

    function purchaseDateFormatter(cell, row) {
        return (
            <>
                <TradeDetailsDrawer userId={props.userId} role={props.role} mobileView={props.mobileView} planTradeId={row.idplan_trades} link={tableHelpers.dateFormmatter(cell, row)} />
            </>
        )
    }

    function symbolFormatter(cell, row) {
        return <div class='sameline'>
            <StockQuickLookDrawer planId={props.planId} accountId={props.accountId} userId={props.userId} mobileView={props.mobileView} symbol={cell} role={props.role} />
            &nbsp;<Link onClick={() => setPopupChartSymbol(cell)}> 📈</Link>
        </div>
    }

    function openPlaceTradeModal(symbol, quantity) {
        setTrade({
            symbol: symbol,
            shares: Number(quantity)
        })
        setIsPlacingOrder(true);
    }

    function getChartData() {

        let ret = [["Algo", "Profit", { role: "style" }, "Net", { id: "net", role: "annotation", type: "string" }]];

        let trades = getTrades().sort((a, b) => new Date(a.dollarProfit) - new Date(b.dollarProfit));
        let total = trades.reduce((sum, trade) => sum + trade.dollarProfit, 0);
        let count = 0;
        trades.forEach(trade => {
            let algo = trade.display_name;
            let profit = trade.dollarProfit;
            let color = profit >= 0 ? "#B2D8B2" : "#B85D5D"
            let annotation = null;
            if (++count === trades.length) {
                annotation = tableHelpers.moneyFormatterNoCents(total);
            }
            ret.push([algo, profit, color, total, annotation]);
        });
        return ret;
    }

    let chartData = getChartData();

    let trades = getTrades();

    return (
        <>
            {trades.length ?
                <RichTable data={getStats()} mappers={[
                    { title: `Count`, field: 'count', formatter: tableHelpers.intFormatter },
                    { title: `Win %`, field: 'winningPct', formatter: tableHelpers.percentFormatter },
                    { title: `Net`, field: 'netProfit', formatter: tableHelpers.moneyChangeFormatterNoCents },
                    { title: `Today's Change`, field: 'todaysChange', formatter: tableHelpers.moneyChangeFormatterNoCents },
                    { title: `Market Value`, field: 'totalMarketValue', formatter: tableHelpers.moneyFormatterNoCents, hidden: props.mobileView },
                ]} className="table-striped table-hover table-condensed" />
                : null}

            {chartData.length <= 1 || props.hideCharts ? null :
                <center><Chart
                    chartType="ComboChart"
                    data={chartData}
                    width={props.mobileView ? "400px" : "800px"}
                    height={props.mobileView ? "250px" : "300px"}
                    chartPackages={["corechart", "controls"]}
                    options={{
                        legend: 'none',
                        seriesType: "bars",
                        series: {
                            1: { type: "line" },
                        },
                        bar: { width: "20" },
                    }}
                />
                </center>}

            <div style={{ width: '100%' }}>
                <RichTable data={trades} mappers={[
                    { title: `Purch Date`, field: 'purchase_date', formatter: purchaseDateFormatter, sorters: createDateSorter('purchase_date'), hidden: props.mobileView, isDefaultSort: true },
                    { title: `Symbol`, field: 'trade_symbol', formatter: symbolFormatter, sorters: true },
                    { title: `Algo`, field: 'display_name', sorters: true, formatter: algoLinkFormatter },
                    { title: `P/L`, field: 'dollarProfit', sorters: true, formatter: tableHelpers.moneyChangeFormatterNoCents },
                    { title: `Today`, field: 'trade_symbol', sorters: true, formatter: todayChangeFormatter },
                    { title: `Shares`, field: 'user_amount', sorters: true, formatter: sharesFormatter, hidden: props.mobileView },
                    { title: `Market Value`, field: 'marketValue', sorters: true, formatter: tableHelpers.moneyFormatterNoCents, hidden: props.mobileView },
                ]} className="table-striped table-hover table-condensed" />
            </div >

            <Drawer
                anchor={'bottom'}
                open={popupChartSymbol !== null}
                onClose={() => setPopupChartSymbol(null)}
            >
                <center>
                    <TradingViewChart symbol={popupChartSymbol} />
                </center>
            </Drawer>

            <EditTrade isOpen={isEditingTrade && editTrade}
                onClose={onStopEditingTrade}
                userTradeId={editTrade ? editTrade.user_trade_id : null}
            />

            <AutomateTrade brokerage={props.brokerage} trade={trade} userId={props.userId} accountId={props.accountId} isOpen={isPlacingOrder} onClose={() => setIsPlacingOrder(false)} mobileView={props.mobileView} />
        </>
    );
}

export default ActiveBonusTrades;